import { Box, Typography, Switch } from "@mui/material";
import axios from "axios";
import { useState } from "react";

const ParticipationSwitch = ({ dateIso, menuId, participationInitiale, t, showSnackbar }) => {
  const [participation, setParticipation] = useState(participationInitiale);

  const handleChange = (e) => {
    const value = e.target.checked;
    setParticipation(value);

    axios
      .put(`${process.env.REACT_APP_API}/menusjournalier/${menuId}`, {
        participationUtilisateurs: {
      [dateIso]: value
    }
  })
      .then(() => {
        showSnackbar({
          message: value ? t("AllowUsersToParticipate") : t("NotAllowUsersToParticipate"),
          severity: "success",
          emoji: "⚠️"
        });
      })
      .catch(() => {
        setParticipation(!value);
        showSnackbar({
          message: t("Error"),
          severity: "error",
          emoji: "⚠️"
        });
      });
  };

  return (
    <Box
      sx={{
        mt: 1,
        mb: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 1
      }}
    >
      <Typography sx={{ fontSize: { xs: "0.65rem", sm: "1rem" } }}>
        {t("AllowUsersToParticipate")}
      </Typography>

      <Switch checked={participation} onChange={handleChange} />
    </Box>
  );
};

export default ParticipationSwitch;
